import request from '@/utils/request'

export default {
  /**
   * @returns {*}
   */
  getInfo() {
    return request.get('/accounts/info/mine')
  },

  /**
   * 获取当前登录用户的员工信息
   */
  getStaffInfo() {
    return request.get('/accounts/staff/info')
  },

  /**
   * 获取公众号登录二维码
   */
  getLoginQrcode() {
    return request.get('/site/login/qrcode')
  },

  /**
   * 获取登录结果
   */
  getLoginResult(key) {
    return request.get(`/simple-kv/get/${key}`)
  },

  /**
   * 当前账号有权限的商家账号列表
   * @returns {*}
   */
  availableAccountMerchants() {
    return request.get('/accounts/account-merchants/available')
  }
}
